import { useSearchParams } from 'react-router-dom';

export const QUICK_PURCHASE_PROGRAM_ID_PARAM = 'programId';
export const QUICK_PURCHASE_CURRENCY_PARAM = 'currency';

export interface QuickPurchaseParams {
  programId: string | null;
  currency: string | null;
  isValid: boolean;
}

/**
 * Reads and validates `programId` and `currency` query params from the URL.
 * `programId` is required; `currency` is optional (falls back to USD on the backend).
 */
export const useQuickPurchaseParams = (): QuickPurchaseParams => {
  const [searchParams] = useSearchParams();

  const programId = searchParams.get(QUICK_PURCHASE_PROGRAM_ID_PARAM);
  const currency = searchParams.get(QUICK_PURCHASE_CURRENCY_PARAM);

  const isValid = Boolean(programId && programId.trim().length > 0);

  return { programId, currency, isValid };
};
